
import {loadAudioContent, loadNewContent, loadOldContent} from '../parser/CartoonistXMLParser';

export const types = {
    ADD_SLIDE: 'add_slide',
    LOADED_OLD_PRODUCTION: 'loaded_old_production',
    LOADED_NEW_PRODUCTION: 'loaded_new_production',
    CONTENT_XML_LOADED: 'content_xml_loaded',
    UPDATE_CURRENT_SLIDE: 'update_current_slide',
    CHANGE_SLIDE_POSITION: 'change_slide_position',
    DUPLICATE_SLIDE: 'duplicate_slide',
    DUPLICATE_SLIDE_END_ANIMATION: 'duplicate_slide_end_animation',
    DELETE_SLIDE: 'delete_slide',
    SET_WINDOW_SIZE: 'set_window_size',
    CHANGE_MODE: 'change_mode',
    SHIFT_SLIDE: 'shift_slide',
    SET_SLIDE_CLONE_TARGET: 'set_slide_clone_target',
    CLONE_SLIDE: 'clone_slide',
    PRODUCTION_UNDO_REDO_ACTION: 'production_undo_redo_action',
    ADD_STORY_SOUND: 'add_story_sound',
    CHANGE_STORY_SOUND_VOLUME: 'change_story_sound_volume',
    UPDATE_PRODUCTION_MOODS: 'update_production_moods',
    CHANGE_SLIDE_PROPERTY: 'change_slide_property',
    ADD_SPLITTED_SLIDE: 'add_splitted_slide',
    SET_EXPORT_PROPERTIES: 'set_exporter_properties'
};

export function loadOldProduction () {
    const production = loadOldContent();
    return { type: types.LOADED_OLD_PRODUCTION, production};
}

export function loadNewProduction (data) {
    const production = loadNewContent(data);
    return { type: types.LOADED_NEW_PRODUCTION, production};
}

export function loadAudioProduction (data) {
    const production = loadAudioContent(data);
    return { type: types.LOADED_NEW_PRODUCTION, production};
}

export function contentXMLLoaded(data) {
    return { type: types.CONTENT_XML_LOADED, data};
}

export function addSlide(index) {
    return { type: types.ADD_SLIDE, index};
}

export function updateCurrentSlide() {
    return { type: types.UPDATE_CURRENT_SLIDE};
}

export function changeSlidePosition(startPosition, endPosition) {
    return { type: types.CHANGE_SLIDE_POSITION, startPosition, endPosition};
}

export function shiftSlide(isLeft, currentPosition) {
    return { type: types.SHIFT_SLIDE, isLeft, currentPosition};
}

export function duplicateSlide() {
    return { type: types.DUPLICATE_SLIDE};
}

export function duplicateSlideAtEndOfAnimation() {
    return { type: types.DUPLICATE_SLIDE_END_ANIMATION};
}

export function deleteSlide() {
    return { type: types.DELETE_SLIDE};
}

export function setWindowSize(width, height) {
    return { type: types.SET_WINDOW_SIZE, width, height};
}

export function changeMode(mode) {
    return { type: types.CHANGE_MODE, mode};
}

export function setSlideCloneTarget(slide) {
    return { type: types.SET_SLIDE_CLONE_TARGET, slide};
}

export function cloneSlide(target) {
    return { type: types.CLONE_SLIDE, target};
}

export function productionUndoRedoAction(newState) {
    return { type: types.PRODUCTION_UNDO_REDO_ACTION, newState};
}

export function addStorySound(audioItem) {
    return { type: types.ADD_STORY_SOUND, audioItem};
}

export function changeStorySoundVolume(volume) {
    return { type: types.CHANGE_STORY_SOUND_VOLUME, volume};
}

export function updateProductionMoods() {
    return { type: types.UPDATE_PRODUCTION_MOODS};
}

export function changeSlideProperty(uuid, propertyType, propertyValue) {
    return { type: types.CHANGE_SLIDE_PROPERTY, uuid, propertyType, propertyValue};
}

export function addSplittedSlide(index, videoModel) {
    return { type: types.ADD_SPLITTED_SLIDE, index, videoModel};
}

export function setExportProperties(properties) {
    return { type: types.SET_EXPORT_PROPERTIES, properties};
}



/** WEBPACK FOOTER **
 ** ./src/actions/ProductionActions.js
 **/